// Show flash messages.

export const PUSH_FLASH_MESSAGE = 'PUSH_FLASH_MESSAGE';
export const CLEAR_FLASH_MESSAGE = 'CLEAR_FLASH_MESSAGE';

export const pushFlashMessage = (message, className = '', flashId = null) => ({
  type: PUSH_FLASH_MESSAGE,
  message: {
    id: flashId || Date.now(),
    className,
    message,
  },
});

export const clearFlashMessage = id => ({
  type: CLEAR_FLASH_MESSAGE,
  id,
});

export const SPLIT_TREATMENTS_FETCH_REQUEST = 'SPLIT_TREATMENTS_FETCH_REQUEST';
export const SPLIT_TREATMENTS_FETCH_SUCCESS = 'SPLIT_TREATMENTS_FETCH_SUCCESS';
export const SPLIT_TREATMENTS_FETCH_ERROR = 'SPLIT_TREATMENTS_FETCH_ERROR';

//Fetch Split Treatments
export const splitTreatmentsFetchRequest = splitTreatments => {
  return {
    splitTreatments,
    type: SPLIT_TREATMENTS_FETCH_REQUEST,
  };
};

export const splitTreatmentsFetchSuccess = splitTreatments => ({
  type: SPLIT_TREATMENTS_FETCH_SUCCESS,
  splitTreatments: splitTreatments.features,
});

export const splitTreatmentsFetchError = error => ({
  type: SPLIT_TREATMENTS_FETCH_ERROR,
  error,
});
